import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "text-4xl font-medium capitalize" }
const _hoisted_3 = { class: "overflow-x-auto" }
const _hoisted_4 = { class: "w-full overflow-scroll table-auto" }
const _hoisted_5 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_7 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_8 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_11 = { class: "px-2 py-3 capitalize" }
const _hoisted_12 = { class: "px-2 py-2 capitalize" }
const _hoisted_13 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_14 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { class: "px-4 py-3 space-x-0 lg:space-x-4" }

import { onUnmounted, ref } from "vue";

import api from "@/api/api";
import { Booking } from "@/types";

import PaymentStatusBadge from "../PaymentStatusBadge.vue";
import { deserializeSlug } from "@/utils/slugify";
import UserBookingsViewButton from "./UserBookingsViewButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBookingsTable',
  props: {
  limit: {
    type: Number,
    required: false,
    default: null,
  },
},
  async setup(__props) {

let __temp: any, __restore: any



const bookings = ref([] as Booking[]);
const urls = ref({} as { training_survery_url: string; outstanding_surveys: [] });

/** Lists bookings where user is user_id on bookings */
bookings.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.bookings.listOwnBookings({ page: 1 }))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.bookings;
urls.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getCourseSurveyLinks())),
  __temp = await __temp,
  __restore(),
  __temp
)).data;

async function fetchBookings() {
  /** Lists bookings where user is user_id on bookings */
  bookings.value = (await api.bookings.listOwnBookings({ page: 1 })).data.bookings;
  urls.value = (await api.surveys.getCourseSurveyLinks()).data;
}

const poll = setInterval(fetchBookings, 30000);

onUnmounted(() => {
  clearInterval(poll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("courses")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_5, [
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("course")), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("course-type")), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("payment-status")), 1),
            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("training-status")), 1),
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("actions")), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.limit ? bookings.value.slice(0, __props.limit) : bookings.value, (booking) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400 divide-x-2 divide-gray-400 odd:bg-gray-200",
              key: booking.id
            }, [
              _createElementVNode("td", _hoisted_11, _toDisplayString(booking.event?.name), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(deserializeSlug)(booking.event!.type)), 1),
              _createElementVNode("td", _hoisted_13, [
                _createVNode(PaymentStatusBadge, { order: booking }, null, 8, ["order"])
              ]),
              _createElementVNode("td", _hoisted_14, [
                (booking.user_attended)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("completed")), 1))
                  : (booking.payment_status === 'abandoned')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("abandoned")), 1))
                    : (booking.payment_status === 'pending')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("not-started")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("not-started")), 1))
              ]),
              _createElementVNode("td", _hoisted_19, [
                _createVNode(UserBookingsViewButton, {
                  booking: booking,
                  urls: urls.value
                }, null, 8, ["booking", "urls"])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})